export const fileChunkSize = 1024 * 1024;
